import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

export default function Compra() {
  const { t } = useTranslation();
  const [vehicles, setVehicles] = useState([]);
  const [openLead, setOpenLead] = useState(null);
  const [form, setForm] = useState({ nombre: "", email: "", telefono: "", mensaje: "" });

  useEffect(() => {
    axios.get(`/api/vehicles?tipo=Venta`).then(r => setVehicles(r.data || [])).catch(() => {});
  }, []);

  const submitLead = async (e) => {
    e.preventDefault();
    try {
      await axios.post("/api/leads-venta", { vehicle_id: openLead.id, ...form });
      toast.success(t("compra.mensajeEnviado"));
      setOpenLead(null);
      setForm({ nombre: "", email: "", telefono: "", mensaje: "" });
    } catch {
      toast.error(t("compra.errorEnviar"));
    }
  };

  return (
    <section className="section-light py-12" data-testid="compra-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="bg-black text-white rounded-lg p-8 mb-8" data-testid="compra-banner">
          <div className="divider-red mb-4"></div>
          <h1 className="font-display text-3xl sm:text-5xl mb-3">{t("compra.tituloBanner")}</h1>
          <p className="text-neutral-300 mb-3">
            {t("compra.descripcionBanner")}
          </p>
          <p className="text-lg">
            <span className="text-[var(--pc-red)] font-bold uppercase">{t("compra.promocionLabel")}</span>{" "}
            {t("compra.promocionTexto")}{" "}
            <span className="text-[var(--pc-red)] font-bold">{t("compra.bono")}</span>.
          </p>
        </div>

        <h2 className="font-display text-3xl mb-6">{t("compra.cochesDisponibles")}</h2>
        {vehicles.length === 0 && (
          <div className="bg-[var(--pc-grey)] p-6 rounded">
            {t("compra.sinCoches")}{" "}
            <a href="https://wa.me/34613807514" className="text-[var(--pc-red)] font-semibold">{t("compra.pideloWhatsapp")}</a>.
          </div>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {vehicles.map(v => (
            <div key={v.id} className="car-card" data-testid={`compra-card-${v.id}`}>
              <div className="aspect-[4/3] overflow-hidden bg-neutral-800">
                <img src={v.imagen_url} alt={v.marca_modelo} className="w-full h-full object-cover" />
              </div>
              <div className="p-5">
                <h3 className="font-display text-xl mb-2">{v.marca_modelo}</h3>
                <div className="text-xs uppercase tracking-wider text-neutral-400 mb-3">
                  {v.año} · {v.km || "-"} km · {v.combustible}
                </div>
                <div className="flex items-end justify-between">
                  <div className="text-2xl font-display text-[var(--pc-red)]">{v.precio_venta ? `${v.precio_venta} €` : t("compra.consultar")}</div>
                  <button onClick={() => setOpenLead(v)} className="btn-red px-4 py-2 text-sm" data-testid={`request-info-${v.id}`}>{t("compra.solicitarInfo")}</button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {openLead && (
          <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" data-testid="lead-modal">
            <div className="bg-white rounded-lg p-6 w-full max-w-md">
              <h3 className="font-display text-2xl mb-1">{t("compra.solicitarInfo")}</h3>
              <p className="text-sm text-neutral-600 mb-4">{openLead.marca_modelo}</p>
              <form onSubmit={submitLead} className="space-y-3">
                <input className="pc-input" placeholder={t("compra.nombre")} required value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})} data-testid="lead-nombre" />
                <input className="pc-input" type="email" placeholder={t("compra.email")} required value={form.email} onChange={e => setForm({...form, email: e.target.value})} data-testid="lead-email" />
                <input className="pc-input" placeholder={t("compra.telefono")} required value={form.telefono} onChange={e => setForm({...form, telefono: e.target.value})} data-testid="lead-telefono" />
                <textarea className="pc-input" placeholder={t("compra.mensaje")} rows="3" value={form.mensaje} onChange={e => setForm({...form, mensaje: e.target.value})} data-testid="lead-mensaje" />
                <div className="flex gap-2 justify-end">
                  <button type="button" onClick={() => setOpenLead(null)} className="px-4 py-2 text-sm">{t("compra.cancelar")}</button>
                  <button type="submit" className="btn-red px-4 py-2 text-sm" data-testid="lead-submit">{t("compra.enviar")}</button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
